<template>
  <BaseLoader :loading="isLoadingGated" />
</template>

<script setup>
  import useAuthStore from '@/stores/authStore';
  import BaseLoader from '@/components/UI/BaseLoader.vue';
  import useGlobalStore from '@/stores/globalStore';
  const HIDE_DELAY_MS = 150;
  const MIN_VISIBLE_MS = 300;

  const globalStore = useGlobalStore();
  const authStore = useAuthStore();
  const isLoadingGated = ref(false);

  let showAt = 0;

  const { start: scheduleHide, stop: cancelHide } = useTimeoutFn(
    () => {
      isLoadingGated.value = false;
    },
    HIDE_DELAY_MS,
    { immediate: false },
  );

  watch(
    () => globalStore.isLoading || authStore.authLoading,
    now => {
      if (now) {
        cancelHide();
        if (!isLoadingGated.value) {
          isLoadingGated.value = true;
          showAt = Date.now();
        }
      } else {
        const wait = Math.max(
          HIDE_DELAY_MS,
          MIN_VISIBLE_MS - Date.now() - showAt,
          0,
        );
        scheduleHide(wait);
      }
    },
    { immediate: true },
  );
</script>
